import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'
import LoanPermissions from 'models/Permissions/AbstractPermissions/LoanPermissions'

class ClientsPermissions extends BaseScenesPermissions {
    constructor({ 
        show = true, 
        enabled = true,
        loan = {}
    } = {}) {
        super({ show, enabled })
        this.loan = new LoanPermissions(loan)
    }
}

export default ClientsPermissions
